import { render, staticRenderFns } from "./ExistingTicket.vue?vue&type=template&id=e47a4240&scoped=true&"
import script from "./ExistingTicket.vue?vue&type=script&lang=js&"
export * from "./ExistingTicket.vue?vue&type=script&lang=js&"
import style0 from "./ExistingTicket.vue?vue&type=style&index=0&id=e47a4240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47a4240",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e47a4240')) {
      api.createRecord('e47a4240', component.options)
    } else {
      api.reload('e47a4240', component.options)
    }
    module.hot.accept("./ExistingTicket.vue?vue&type=template&id=e47a4240&scoped=true&", function () {
      api.rerender('e47a4240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/ExistingTicket.vue"
export default component.exports